import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import ComponentDisplay from 'components/ComponentDisplay'
import React from 'react'
import { ComponentSourceType, getCompositeFunction } from 'types/components'

interface MetricsVisibilityConfirmationDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: (makeVisible: boolean) => void
  selectedMetrics: any[]
  action: 'visible' | 'hidden'
  periodLabelMap: Record<string, string>
  organizationLabelMap: Record<string, string>
}

const MetricsVisibilityConfirmationDialog: React.FC<MetricsVisibilityConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  selectedMetrics,
  action,
  periodLabelMap,
  organizationLabelMap,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>Confirm Make {action === 'visible' ? 'Visible' : 'Hidden'}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          You are about to make {selectedMetrics.length} metric{selectedMetrics.length !== 1 ? 's' : ''} {action}.
          Please review the items below and confirm your action.
        </Typography>

        <TableContainer sx={{ mt: 3, maxHeight: 400 }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Team</strong>
                </TableCell>
                <TableCell>
                  <strong>Period</strong>
                </TableCell>
                <TableCell>
                  <strong>Name</strong>
                </TableCell>
                <TableCell>
                  <strong>Value</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedMetrics.map((metric) => (
                <TableRow key={metric.id}>
                  <TableCell>{organizationLabelMap[metric.organizationId] || metric.organizationId}</TableCell>
                  <TableCell>{periodLabelMap[metric.periodId] || metric.periodId}</TableCell>
                  <TableCell>{metric.label}</TableCell>
                  <TableCell>
                    <ComponentDisplay
                      componentType={metric.componentType}
                      value={metric.value}
                      sourceType={
                        metric.sourceType === ComponentSourceType.COMPONENT_SOURCE_COMPOSITE
                          ? ComponentSourceType.COMPONENT_SOURCE_COMPOSITE
                          : ComponentSourceType.COMPONENT_SOURCE_MANUAL
                      }
                      compositeFunction={getCompositeFunction(metric.sourceInfo)}
                      componentLabel={metric.label}
                      periodLabel={periodLabelMap[metric.periodId]}
                      fontSize="14px"
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={() => onConfirm(action === 'visible')}
          variant="contained"
          color={action === 'visible' ? 'primary' : 'warning'}
        >
          Make {action === 'visible' ? 'Visible' : 'Hidden'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default MetricsVisibilityConfirmationDialog
